// linted by Thang 2020-08-17

import React from 'react';
import '../App.css';
import MobileHeader from '../Components/MobileHeader';

export default function DeniedDeferment({ jurorName, logOut, jurorReportingDateTime, goQuestionnaire }) {
    return (
        <div>
            <MobileHeader jurorName={jurorName} jurorReportingDateTime={jurorReportingDateTime} logOut={logOut} />
            <p />
            <div className="Deferment">
                <p>
                    <div>Thank you for filling out the questionnaire.</div>
                    <div>We have reviewed your questionnaire and denied you for deferment.</div>
                    <div>Please continue filling out your questionnaire.</div>
                    <div>
                        <br />
                        If you have any questions, please contact:
                    </div>
                    <div>The office of Jacquline D. Wills</div>
                    <div>Clerk of Superior Court at 770-477-3400</div>
                    <div>
                        <br />
                        or email the clerk at:
                    </div>
                    <div>
                        <a href="mailto:jury.clerk@claytoncountyga.gov">mailto:jury.clerk@claytoncountyga.gov</a>
                    </div>
                </p>
                <div>
                    <button type="button" className="cta_button" onClick={goQuestionnaire}>
                        Back to Questionnaire
                    </button>
                </div>
            </div>
        </div>
    );
}
